import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { Account } from 'app/api/@generated/backend';

import { ChooseButton } from 'app/components/choose-button';
import { i18n } from 'app/i18n';
import { buildingImageProps, personImageProps } from 'app/resources/images';
import { I18nUtils } from 'app/utils/i18n-utils';
import { OrderStep } from 'app/pages/order/redux/model/order-step';
import { selectAccountActionCreator } from 'app/pages/order/redux/action-creators/select-account-action-creator';
import { useAppDispatch } from 'app/hooks/thunk-hooks';
import { selectPartners, selectSelectedAccount } from 'app/pages/order/redux/order-selector';
import { PartnerUtils } from 'app/pages/order/utils/partner-utils';
import { useGoToStep } from 'app/hooks/use-go-to-step';

import { StyledTitle } from './choose-account-button.styled';

interface Props {
    account: Account;
}

export const ChooseAccountButton: FC<Props> = (props) => {
    const {
        account,
        account: { partnerId, customerId, name },
    } = props;
    const dispatch = useAppDispatch();
    const selectedAccount = useSelector(selectSelectedAccount);
    const partners = useSelector(selectPartners);
    const partner = partnerId && PartnerUtils.getPartnerById(partners, partnerId);
    const goToStep = useGoToStep();

    const handleClick = () => {
        if (!(selectedAccount?.customerId === account.customerId && selectedAccount?.partnerId === account.partnerId)) {
            dispatch(selectAccountActionCreator(account));
        }
        goToStep(OrderStep.CHOOSE_SERVICE_LOCATION);
    };

    return (
        <ChooseButton
            onClick={() => handleClick()}
            key={customerId}
            title={
                <StyledTitle variant="paragraph2" component="p" data-hj-suppress={true}>
                    {name}
                </StyledTitle>
            }
            items={[
                {
                    text: `${i18n.page.chooseAccount.customerId} ${customerId}`,
                    icon: personImageProps,
                    isValueSensitive: true,
                },
                ...(partner
                    ? [
                          {
                              text: I18nUtils.message(i18n.page.chooseAccount.deliveredBy, {
                                  partnerName: partner.name,
                              }),
                              icon: buildingImageProps,
                          },
                      ]
                    : []),
            ]}
        />
    );
};
